import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    width: '100%',
    padding: `0 ${spacing(3)}`
  },
  rootCollapsed: {
    padding: `0 ${spacing(3)} ${spacing(3)}`
  },
  accordion: {
    '&:before': {
      display: 'none'
    }
  },
  accordionExapanded: {
    margin: '0 !important'
  },
  heading: {
    fontSize: 20,
    fontWeight: 500,
    color: palette.text.primary
  },
  headingActive: {
    color: palette.text.primary
  },
  subHeading: {
    fontSize: 15,
    fontWeight: 500,
    paddingBottom: '5px',
    color: palette.text.primary
  },
  subtitleMap: {
    color: 'rgba(0, 0, 0, 0.6)'
  },
  summary: {
    padding: 0,
    height: 72,
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
  },
  detail: {
    padding: 0
  }
}))
